import React, { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
//
import Box from "@mui/material/Box";
// import MyDateRangePicker from "../../../../../components/calendar/MyDateRangePicker";
import MyDatePicker from "../../../../../components/calendar/MyDatePicker";
import useLocaleRoute from "../../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../../hooks/useModulePublic";
import { StoreContext } from "../../../../../../store/StoreProvider";
import Selection from "../../../../../../common/components/input/Selection";
//
import Act from "../../../../../../store/actions";
import urls from "../../../../../../api/project/ApiUrls";
import { snaTimePeriodOptions } from "../../../../../../config/config.sna";

const AccordionDetailChildren = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale, group } = user;
  const { filter } = sna;
  const { timePeriod } = filter || {};
  // local state
  const [localOptions, setLocalOptions] = useState(snaTimePeriodOptions);
  const [inputVal, setInputVal] = useState(timePeriod?.initial || "");

  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  useEffect(() => {
    if (timePeriod?.change !== null) {
      setInputVal(timePeriod.change);
    }
  }, [timePeriod]);

  const handleInputChange = (e) => {
    const { value } = e.target;
    setInputVal(value);
    dispatch({
      type: Act.SNA_FILTER_TIME_PERIOD_CHANGE,
      payload: value,
    });
  };

  return (
    <Box>
      <Selection
        options={localOptions}
        size="normal"
        darkMode
        fullWidth
        inputProps={{
          value: inputVal,
          onChange: handleInputChange,
          defaultValue: "",
        }}
        MenuProps={{}}
      />
      <Box my={2}>
        <MyDatePicker />
      </Box>
    </Box>
  );
};

export default AccordionDetailChildren;
